import {Component, EventEmitter, inject, input, Input, Output, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MalfunctionStatus} from "../../../../shared/interfaces/report";
import {Escalation, EscalationEvent, EscalationStatus, getEscalationStatus} from "../../escalation.model";
import {Userrole} from "../../../../shared/interfaces/user";
import {MatDialog, MatDialogModule} from "@angular/material/dialog";
import {ConfirmationDialogComponent} from "../../../../shared/confirmation-dialog/confirmation-dialog.component";
import {NotificationService} from "../../../../shared/data-access/notification.service";

@Component({
  selector: 'app-escalation-details',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  template: `
    <ng-container>

      <!--Concept view - escalation history component with chat-like functionality for issue tracking
      <app-processing-history/>-->

      <div
        class="d-flex justify-content-between mt-3 mb-3">
        <div class="escalation-actions d-flex gap-3">
          @if (user().role !== Userrole.Mitarbeiter) {
            <ng-container>
              @if (isUserAssignedToEscalation() || (escalationDetails().assigned_to_role === user().role && !escalationDetails().assigned_to_user)) {
                <button class="btn btn-qundis-escalation-option qundis-section-heading-h2 px-4 py-1"
                        [class]="escalationDetails().assigned_to_user === user().id
                  && escalationDetails().status === EscalationStatus.ACCEPTED
                  ? 'btn-qundis-primary'
                  : ''"
                        [disabled]="escalationDetails().assigned_to_user === user().id &&
                                escalationDetails().status! >= EscalationStatus.ACCEPTED"
                        (click)="emitEscalationEvent('accept')">
                  <div class="d-flex align-items-center justify-content-center">
                    <span>Gelesen</span>
                    <i class="bi bi-check-lg fs-5 ps-2"></i>
                  </div>
                </button>
                <button class="btn btn-qundis-escalation-option .qundis-section-heading-h2 px-4 py-1"
                        [class]="!(escalationDetails) || escalationDetails().assigned_to_user === user().id &&
                                escalationDetails().status! >= EscalationStatus.IN_PROGRESS
                                  ? 'btn-qundis-primary' : ''"
                        [disabled]="escalationDetails().assigned_to_user === user().id &&
                                escalationDetails().status! >= EscalationStatus.IN_PROGRESS"
                        (click)="emitEscalationEvent('inProgress')">
                  <div class="d-flex align-items-center justify-content-center">
                    <span>in Arbeit</span>
                    <i class="bi bi-tools fs-5 ps-2"></i>
                  </div>
                </button>
              } @else {
                <button
                  class="btn btn-qundis-primary px-4 py-1"
                  (click)="takeOverEscalation()"
                >
                  <div class="d-flex align-items-center justify-content-center">
                    <span>übernehmen</span>
                  </div>
                </button>
              }
            </ng-container>
          }


        </div>
        <div class="qundis-escalation-status d-flex align-items-center">
          <span>STATUS: {{ getEscalationStatus(escalationDetails().status!) }}</span>
        </div>
      </div>
      <div class="mb-3">
        {{ escalationDetails().message }}
      </div>
    </ng-container>
  `,
  styles: [`
    .custom-input {
      padding: 0.5rem 3rem 0.5rem 1rem;
      resize: none;
      background-color: #fff;
      border-color: #dee2e6;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

      &:focus {
        border-color: #86b7fe;
        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.15);
      }
    }

    .fade-transition {
      transition: opacity 0.2s ease;
    }
  `]
})
export class EscalationDetailsComponent {
  readonly #notification = inject(NotificationService);
  protected readonly MalfunctionStatus = MalfunctionStatus;
  protected readonly EscalationStatus = EscalationStatus;
  protected readonly getEscalationStatus = getEscalationStatus;
  private dialog = inject(MatDialog);

  escalationDetails = input.required<Escalation>();
  user = input.required<{ id: string, role: Userrole }>();
  isUserAssignedToEscalation = input.required<boolean>();
  @Output() updateEscalationEvent = new EventEmitter<EscalationEvent>

  emitEscalationEvent(action: EscalationEvent) {
    this.updateEscalationEvent.emit(action)
  }

  takeOverEscalation() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: "Möchten Sie diese Stillstandsmeldung übernehmen?",
        name: "Stillstandsmeldung übernehmen",
        actions: ['cancel', 'confirm']
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.emitEscalationEvent('takeover');
        this.#notification.showNotification('Stillstandsmeldung zugewiesen');
      }
    })
  }

  protected readonly Userrole = Userrole;
}
